import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import MaterialModal from "../../app/material-modal";
import { useDeleteSeat } from "../../../tanstackQuery/queries/superAdmin/invoice";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useKeycloak } from "@react-keycloak/web";
import { toast } from "sonner";

export const DeleteSeatModal = ({ open, handleClose, tableData }) => {

  const { keycloak } = useKeycloak();
  const client = useQueryClient();
  const { orgID } = useParams();

  const {
    mutateAsync: deleteSeat,
    isPending,
    isSuccess,
  } = useDeleteSeat(
    { accessToken: keycloak?.token },
    {
      onSuccess: () => {
        client.invalidateQueries({ queryKey: ["orgUserList"]});
        handleClose();
      },
    }
  );

  const handleDelete = async() => {
    const resultValues={
      orgID,
      userID:tableData?.userID,
      seatID:tableData?.seatID,
    }
    
    try{
      await deleteSeat(resultValues);
      if(isSuccess){
        toast.success("Seat successfully removed!");
      }
    }
    catch(error){
      toast.error(error?.response?.data?.message || "Failed to remove seat.");
    }
  }

  return (
    <MaterialModal
      title={`Delete seat`}
      open={open}
      onClose={handleClose}
      handleDialogClose={handleClose}
      styleOverrides={{
        container: {
          "& .MuiDialog-paper": {
            width: "100%",
            minWidth: "300px",
            minHeight: "200px",
          },
        },
      }}
    >
      <Box>
        <Typography variant="subtitle1">
          Are you sure you want to permanently delete the seat for {" "}
          <span style={{ fontWeight: "bold" }}>
            {/* "{data?.group?.name}" {data?.group?.groupType}? */}
          </span>{" "}
          This action will remove all associated information and cannot be
          undone.
        </Typography>

        <Stack direction="row" justifyContent="flex-end" gap={1} mt={2}>
          <Button variant="outlined" onClick={handleClose}>
            No
          </Button>
          <Button
            disabled={isPending}
            variant="contained"
            onClick={handleDelete}
            endIcon={ isPending ? ( <CircularProgress size={15} color="primary" /> ) : null }
          >
            Yes
          </Button>
        </Stack>
      </Box>
    </MaterialModal>
  );
};